import { defineMessages } from 'react-intl';

export const trustBadgesMessages = defineMessages({
  trustedByClinicians: {
    defaultMessage: 'Fully compliant and trusted by {count, number}+ clinicians',
    id: 'Hn7ho9IcpN',
    description:
      'Signup trust line showing clinician count above compliance badges. The plus sign is part of the copy so translators can place it around a locale-formatted number.',
  },
  APP: {
    defaultMessage: 'APP Compliant',
    id: '5/Ffm6QxJ9',
    description: 'Australian Privacy Principles compliance badge label',
  },
  NHS: {
    defaultMessage: 'NHS Compliant',
    id: 'Q+4T/UUA77',
    description: 'NHS compliance badge label',
  },
  ISO: {
    defaultMessage: 'ISO:27001 Accredited',
    id: '9Q1l7EOzQr',
    description: 'ISO 27001 accreditation badge label',
  },
  NZ: {
    defaultMessage: 'NZ Info Privacy Principles',
    id: 'Bc/eiPkq0Q',
    description: 'New Zealand Information Privacy Principles badge label',
  },
  PIPEDA: {
    defaultMessage: 'PIPEDA Compliant',
    id: 'V86EF6esRP',
    description: 'PIPEDA compliance badge label',
  },
  SOC: {
    defaultMessage: 'SOC 2 Compliant',
    id: '34jQiYYvwO',
    description: 'SOC 2 compliance badge label',
  },
  UKCA: {
    defaultMessage: 'UK Conformity Assessed',
    id: 'W0QEt4yJWv',
    description: 'UKCA compliance badge label',
  },
  GDPR: {
    defaultMessage: 'GDPR Compliant',
    id: 'yTO/KYy0nV',
    description: 'GDPR compliance badge label',
  },
  UKGDPR: {
    defaultMessage: 'UK GDPR Compliant',
    id: 'vnyJBaMX9a',
    description: 'UK GDPR compliance badge label',
  },
  HIPAA: {
    defaultMessage: 'HIPAA Compliant',
    id: 'VCk32E+Xnc',
    description: 'HIPAA compliance badge label',
  },
  TXRAMP: {
    defaultMessage: 'TX-RAMP Compliant',
    id: '36AuRKVhRN',
    description: 'TX-RAMP compliance badge label',
  },
  DSGVO: {
    defaultMessage: 'DSGVO Konform',
    id: 'I+WS0HWjn4',
    description: 'German DSGVO compliance badge label',
  },
});

export const COMPLIANCE_BADGE_MESSAGE_BY_KEY = {
  'auth.complianceBadges.APP': trustBadgesMessages.APP,
  'auth.complianceBadges.NHS': trustBadgesMessages.NHS,
  'auth.complianceBadges.ISO': trustBadgesMessages.ISO,
  'auth.complianceBadges.NZ': trustBadgesMessages.NZ,
  'auth.complianceBadges.PIPEDA': trustBadgesMessages.PIPEDA,
  'auth.complianceBadges.SOC': trustBadgesMessages.SOC,
  'auth.complianceBadges.UKCA': trustBadgesMessages.UKCA,
  'auth.complianceBadges.GDPR': trustBadgesMessages.GDPR,
  'auth.complianceBadges.UKGDPR': trustBadgesMessages.UKGDPR,
  'auth.complianceBadges.HIPAA': trustBadgesMessages.HIPAA,
  'auth.complianceBadges.TXRAMP': trustBadgesMessages.TXRAMP,
  'auth.complianceBadges.DSGVO': trustBadgesMessages.DSGVO,
} as const;
